'use strict';

/**
 * Dependencies
 * @ignore
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var base64url = require('base64url');
var crypto = require('@trust/webcrypto');
var TextEncoder = require('../text-encoder');

/**
 * AES-GCM
 */

var AES_GCM = function () {

  /**
   * constructor
   *
   * @param {string} bitlength
   */
  function AES_GCM(params) {
    _classCallCheck(this, AES_GCM);

    this.params = params;
  }

  /**
   * encrypt
   *
   * @description
   * Encrypt data and associated additional authentication data using AES-GCM.
   *
   * @param {CryptoKey} key
   * @param {BufferSource} data
   * @param {BufferSource} aad
   *
   * @returns {Promise}
   */


  _createClass(AES_GCM, [{
    key: 'encrypt',
    value: function encrypt(key, data, aad) {
      var algorithm = Object.assign({}, this.params);
      // ensure each encryption has a new iv
      Object.defineProperty(algorithm, 'iv', {
        enumerable: false,
        configurable: true,
        value: crypto.getRandomValues(new Uint8Array(16))
      });
      Object.defineProperty(algorithm, 'aad', {
        enumerable: false,
        configurable: true,
        value: aad
      });

      data = new TextEncoder().encode(data);

      return crypto.subtle.encrypt(algorithm, key, data).then(function (result) {
        // split the result into ciphertext and tag
        var tagLength = algorithm.tagLength / 8 || 16;
        var tag = result.slice(result.byteLength - tagLength);
        var ciphertext = result.slice(0, -tagLength);

        return {
          iv: base64url(Buffer.from(algorithm.iv)),
          ciphertext: base64url(Buffer.from(ciphertext)),
          tag: base64url(Buffer.from(tag))
        };
      });
    }

    /**
     * decrypt
     *
     * @description
     * Decrypt the given data (authenticated with the aad) encrypted with iv,
     * checking for integrity using the tag provided.
     *
     * @param {CryptoKey} key
     * @param {string} ciphertext
     * @param {string} iv
     * @param {string} tag
     * @param {string} aad
     *
     * @return {Promise}
     */

  }, {
    key: 'decrypt',
    value: function decrypt(key, ciphertext, iv, tag, aad) {
      var algorithm = this.params;
      Object.defineProperty(algorithm, 'iv', {
        enumerable: false,
        configurable: true,
        value: Uint8Array.from(base64url.toBuffer(iv))
      });
      Object.defineProperty(algorithm, 'aad', {
        enumerable: false,
        configurable: true,
        value: aad
      });

      // Decode ciphertext and tag from base64
      ciphertext = base64url.toBuffer(ciphertext);
      tag = base64url.toBuffer(tag);

      // Concatenate the two buffers
      var data = new Uint8Array(ciphertext.length + tag.length);
      data.set(new Uint8Array(ciphertext), 0);
      data.set(new Uint8Array(tag), ciphertext.length);
      data = data.buffer;

      return crypto.subtle.decrypt(algorithm, key, data).then(function (plaintext) {
        return Buffer.from(plaintext).toString();
      });
    }

    /**
     * encryptKey
     *
     * @description
     * Wrap key using AES-GCM.
     *
     * @param {CryptoKey} key
     * @param {CryptoKey} wrappingKey
     *
     * @returns {Promise}
     */

  }, {
    key: 'encryptKey',
    value: function encryptKey(key, wrappingKey) {
      var algorithm = this.params;
      return Promise.resolve();
      // return crypto.subtle
      // .wrapKey('jwk', key, wrappingKey, algorithm)
    }

    /**
     * decryptKey
     *
     * @description
     * Unwrap key using AES-GCM.
     *
     * @param {string|Buffer} wrappedKey
     * @param {CryptoKey} unwrappingKey
     * @param {string} unwrappedKeyAlg
     *
     * @returns {Promise}
     */

  }, {
    key: 'decryptKey',
    value: function decryptKey(wrappedKey, unwrappingKey, unwrappedKeyAlg) {
      var algorithm = this.params;
      return Promise.resolve();
      // return crypto.subtle
      // .unwrapKey('jwk', wrappedKey, unwrappingKey, algorithm, unwrappedKeyAlgorithm, true, keyUsages)
    }

    /**
     * Generate Key
     *
     * @description
     * Generate key for AES-GCM.
     *
     * @param {boolean} extractable
     * @param {Array} key_ops
     * @param {Object} options
     *
     * @return {Promise}
     */

  }, {
    key: 'generateKey',
    value: function generateKey(extractable, key_ops) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var algorithm = this.params;
      return crypto.subtle.generateKey(algorithm, extractable, key_ops);
    }

    /**
     * Import
     *
     * @description
     * Import a key in JWK format.
     *
     * @param {CryptoKey} key
     *
     * @return {Promise}
     */

  }, {
    key: 'importKey',
    value: function importKey(key) {
      var jwk = Object.assign({}, key);
      var algorithm = this.params;
      var usages = key['key_ops'] || ['encrypt', 'decrypt'];

      return crypto.subtle.importKey('jwk', jwk, algorithm, true, usages).then(function (cryptoKey) {
        Object.defineProperty(jwk, 'cryptoKey', {
          enumerable: false,
          value: cryptoKey
        });

        return jwk;
      });
    }
  }]);

  return AES_GCM;
}();
/**
 * Export
 */


module.exports = AES_GCM;


//////////////////
// WEBPACK FOOTER
// ./~/@trust/jwa/lib/algorithms/AES-GCM.js
// module id = 28
// module chunks = 0